import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';

/**
 * <gp-side-panel>
 */
@Component({
  selector: 'gp-side-panel',
  templateUrl: './side-panel.component.html',
  styleUrls: ['./side-panel.component.scss']
})
export class SidePanelComponent implements OnInit, AfterViewInit {
  /** Tolerance (px) to absorb sub-pixel rounding and scrollbar width when checking viewport edge. */
  private static readonly VIEWPORT_RIGHT_TOLERANCE = 10;

  @Input() isSidePanelOpen = false;
  @Input() sidePanelTitle: string;
  @Input() sidePanelSubTitle: string;

  @Output() isSidePanelOpenChange = new EventEmitter<boolean>();

  animated = true;

  constructor(private host: ElementRef<HTMLElement>, private cdr: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.resolveAnimated();
  }

  ngAfterViewInit(): void {
    if (this.resolveAnimated()) {
      this.cdr.detectChanges();
    }
  }

  toggleSidePanel() {
    this.isSidePanelOpen = !this.isSidePanelOpen;
    this.isSidePanelOpenChange.emit(this.isSidePanelOpen);
  }

  /**
   * Determine if side panel can be animated or not. Returns true if the animated state has changed, false otherwise.
   */
  private resolveAnimated(): boolean {
    const previous = this.animated;
    this.animated = this.isParentStuckToViewportRight();
    return this.animated !== previous;
  }

  private isParentStuckToViewportRight(): boolean {
    const parent = this.host.nativeElement.parentElement;
    if (!parent) {
      return true;
    }
    return parent.getBoundingClientRect().right >= window.innerWidth - SidePanelComponent.VIEWPORT_RIGHT_TOLERANCE;
  }
}
